import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const TYPOGRAPHY = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    fontWeight: theme.base.fontRegular,
    body: {
      color: theme.color.bodyFont
    },
    small: {
      color: theme.color.mutedFont
    },
    heading: {
      color: theme.color.headingFont
    },
    subheading: {
      color: theme.color.subheadingFont
    }
  };
});